module.exports = __webpack_public_path__ + "img/hq-xz.7196e2a2.png";